module.exports = __webpack_public_path__ + "img/search.a409da05.svg";